import { deepMergeAll } from '../logic/deepMerge';

/**
 * A Derivative is a derivate of the Project
 * @typedef {Object} Derivative
 * @property {string} name
 * @property {string} className
 * @property {array} urls
 */

const STORAGE_KEY = 'derivative';

const defaultDerivative = {
  appGuid: '15C84022-4196-468E-B4C3-C4AB31E9ABFF',
  displayName: 'Pendlerportal',
  name: 'Pendlerportal',
  className: 'pp40',
  urls: ['https://pendlerportal.de'],
  pois: [],
  socialLink: { facebook: 'https://de-de.facebook.com/Pendlerportal' },
  sections: {
    mainParagraph: true,
    companies: false,
    mainFeatures: true,
    mainImpact: true,
    mainAdvantage: true,
    mainCo2Calculator: false,
    mainWidget: false,
    mainAbout: true,
    mainCustom: false,
  },
  luggageOptions: ['suitcase', '2_suitcases', 'handbag'],
};

const safeParse = (json) => {
  try {
    return JSON.parse(json);
  } catch {
    return null;
  }
};

const mergeDerivative = (parsed) =>
  deepMergeAll({}, defaultDerivative, parsed || {});

/**
 * @name useDerivative
 * @description useDerivative returns the current derivative, if none present, returns ''
 * @returns {Derivative} The found or not found Derivative
 */
const useDerivative = () => {
  if (typeof window === 'undefined') return defaultDerivative;
  const raw = window.localStorage.getItem(STORAGE_KEY);
  return mergeDerivative(safeParse(raw));
};

export default useDerivative;
